module.exports = __webpack_public_path__ + "img/card_4.e17510c7.jpeg";